<template>
    <div v-if="!$auth.loading"  class="flex flex-around flex-col items-center">
      <!-- show login when not authenticated -->
      
      <!-- <button class=" mt-10 lg:w-1/2 lg:rounded-full rounded bg-pink-500 text-white font-bold p-4 uppercase border-blue-500 border"
      v-if="!$auth.isAuthenticated()" @click="login">Log in</button> -->

        <div class="flex-col justify-center content-center items-baseline lg:mt-10">

            <img class="rounded-full p-1 lg:p-4 object-cover bg-white h-24 w-24 lg:h-48 lg:w-48" src="@/assets/images/full-logo.jpg">
        </div>

        <div v-if ="$countryCode == 'KW'" class="mt-2 lg:mt-10 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                <strong>{{$t('home.kuwaitiWork')}}
                </strong>
        </div>

        <!-- <div v-if ="$countryCode == 'KW'" class="mt-8 lg:mt-20 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                <strong>{{$t('home.kuwaitiWork')}}
                </strong>
        </div> -->
        
        <div v-if="loader">

            <!-- <orbitals-loader ></orbitals-loader>  -->

            <circle-loader></circle-loader>

        </div>
        <div v-else>

            <div v-if="!isAuthenticated && !loader" class="flex flex-around flex-col items-center ">

                <!-- <label class=" mt-10 h-20 w-full lg:w-1/2">{{ this.$t('menu.forClassesLogin')}} </label> -->


                <button class="mt-2 w-full font-bold p-4 uppercase border 
                hover:bg-red-400 hover:text-white active:bg-red-400 focus:outline-none focus:shadow-outline" 
                :class="{'my-btn my-btn-pink': isPinkStyle, 'my-btn my-btn-blue': !isPinkStyle}"
                v-if="!key" @click="login">{{$t('home.login')}}</button>

                <!-- <button class="btn-blue" 
                v-if="!key" @click="login">{{ this.$t('home.login')}}</button> -->
                <button class=" mt-2 w-full lg:rounded-full rounded bg-pink-500
                hover:bg-red-400 hover:text-white active:bg-red-400 focus:outline-none focus:shadow-outline
                 text-white font-bold p-4 uppercase border-blue-500 border"
                v-if="key" @click="autoSign">{{$t('home.loginAgain')}}</button>
            </div>

            <div v-if="isAuthenticated" class="w-full">
                
                <button class=" mt-2 w-full lg:rounded-full rounded bg-pink-500 
                hover:bg-red-400 hover:text-white active:bg-red-400 focus:outline-none focus:shadow-outline
                 text-white font-bold p-4 uppercase border-blue-500 border"
                @click="logout" style="transition: all .15s ease">{{ this.$t('home.logOut')}}</button>

            </div>

        </div>
        
    </div>



</template>

<script>

import componentsHelpers from '../classes/componentHelpers';

import { CircleLoader } from 'vue-spinners-css';

import moment from 'moment';

export default {

    // async created(){

    //     let result = await this.$auth.isAuthenticated();
        
    //     this.isAuthenticated = result;
        
    //     console.log(`Created, inside login.vue component and authentication is ${result}`);
    // },

     async mounted(){


        //         if(this.$isPinkStyle == 'pink'){

        //             console.log(`in pink true`);

        //             this.isPinkSyle = true;
        //         }else{

        //             console.log(`in pink false`);
                    
        //             this.isPinkSyle = false;
        //         }

         try{

            this.loader = true;
            // console.log(`in login`);

            let result = await this.$auth.isAuthenticated();
            this.isAuthenticated = result;
            // console.log(`isAuthenticated :${this.isAuthenticated}`);
            const todayDate = moment(new Date()).format(moment.HTML5_FMT.DATE);
            
            // console.log(`todayDate: ${todayDate}`);

            if(!this.isAuthenticated){
                

                if (this.key != null && this.key != '')
                {

                    // console.log(`before lastReloginRedirect`);

                    if(localStorage.hasOwnProperty('lastReloginRedirect')){


                    // console.log(`after lastReloginRedirect: ${localStorage.getItem('lastReloginRedirect')}`);

                        const dayDate = localStorage.getItem('lastReloginRedirect');

                        // console.log(`dayDate: ${dayDate}`);

                        if(todayDate == dayDate){

                        // console.log(`todayDate == dayDate`);

                            return;
                        }else{

                            // console.log(`todayDate != dayDate`);

                            localStorage.setItem('lastReloginRedirect', todayDate);

                            await this.$auth.login();
                        }
                    }else{

                        localStorage.setItem('lastReloginRedirect', todayDate);
                    }
                }

                this.loader = false;

                // localStorage.setItem('lastReloginRedirect', "202020");
                // console.log(localStorage.getItem('lastReloginRedirect'))

            }
                    
         }catch(e){
            
            this.loader = false;

            this.isAuthenticated = false;

            componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'Mounted', e);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
         }
    },

    computed:{

        // isPinkSyle(){

        //     return componentsHelpers.isPinkSyle();
        // }
        // isPinkStyle(){
            
        //     console.log(`in computed and typeof of mystyle: ${typeof this.$myStyle}, mystyle: ${this.$myStyle}`);

        //         //     let myStyle;

        //         if(this.$myStyle == 'pink'){

        //             return true;
        //         }else{

        //             return false;
        //         }
        //     }
 
        //     isPinkStyle(){

        //     let myStyle;
            
        //     console.log(`in computed`);

        //     if(localStorage.hasOwnProperty('myStyle')){

        //         myStyle = localStorage.getItem('myStyle');

        //         if(myStyle == 'pink'){

        //             con
        //             return true;
        //         }else{

        //             return false;
        //         }
        //     }
        //     else{

        //         return true;
        //     }
        // }
    },

    props: {

        reloadAfterLogout: Function
    },

    components: {

        CircleLoader
    },

    methods: {
        // Log the user in
       async login() {
            //this.$auth.loginWithRedirect();

            try{
                
                this.loader = true;
                await this.$auth.login();
                this.loader = false;
            }catch(e){

                this.loader = false;

                // console.log(` error is ${e}`);
                // return;
                
                componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'login', e);
                
                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                
            }
        },

       async autoSign(){

                await this.$auth.login();
        },
        // Log the user out
        async logout() {
                   
            // console.log('in logout to home');

            try{

            await this.$apollo.provider.defaultClient.resetStore();
            
            }catch(e){

                componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'logOut', JSON.stringify(e));
    
                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            }

            // this.$auth.logout({
            //     returnTo: window.location.origin
            // });

            // console.log('before auth and going to home');

            await this.$auth.logout();

        //    console.log('before going to home');
           
        //    this.$router.push({ name: 'home' })
        
        this.reloadAfterLogout();
        },

    },

  data:function() {

      return {
        
          loader: false,
          isAuthenticated: false,
          key: localStorage.getItem('for_pnadi') !== '' ? localStorage.getItem('for_pnadi') : '',
          isPinkStyle: true

        //    get isPinkStyle() {

        //        let myStyle;
        //         if(localStorage.hasOwnProperty('myStyle')){

        //             myStyle = localStorage.getItem('myStyle');

        //             if(myStyle == 'pink'){

        //                 console.log(`pink is true`);
        //                 return true;
        //             }else{

        //                 console.log(`pink is false`);
        //                 return false;
        //             }
        //         }
        //         else{

        //             console.log(`pink is true`);
        //             return true;
        //         }
        //     },
        };
    },

    watch: {
        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;

            // console.log(`in Watcehr: pink is ${newValue}`);
            }
        }

    // watch: {
    //     '$myStyle'(newValue) {

    //         console.log(`in watch and typeof of mystyle: ${typeof this.$myStyle}, mystyle: ${this.$myStyle}`);

    //             if(this.$myStyle == 'pink'){

    //                 console.log(`in pink true`);

    //                 this.isPinkSyle = true;
    //             }else{

    //                 console.log(`in pink false`);

    //                 this.isPinkSyle = false;
    //             }
    //     }
    // }
}
</script>

<style>

</style>